export const ProductSubscriptionType = {
	MachineLockedLicence: 0,
	OrgEnabledLicence: 1,
} as const;
